<div class="responsive-product-section">

    <div class="container">

        <!-- Section Title -->
        <div class="section-title" *ngFor="let Content of sectionTitle">
            <h2>{{Content.title}}</h2>
        </div>

        <!-- Products -->
        <div class="row g-3 g-md-4">

            <div class="col-12 col-sm-6 col-lg-4 col-xl-3"
                 *ngFor="let Content of singleProductsItem">

                <div class="single-products-item">

                    <!-- Product Image -->
                    <div class="products-image">

                        <a [routerLink]="['/product', Content.keywords]"
                           class="product-image-link">

                            <img [src]="Content.mainImg"
                                 [alt]="Content.title"
                                 class="responsive-img"
                                 loading="lazy">

                        </a>

                        <!-- Product Buttons -->
                        <ul class="products-button">

                            <li>
                                <a [routerLink]="['/product', Content.keywords]"
                                   title="View Product">
                                    <i class="bx bx-show-alt"></i>
                                </a>
                            </li>

                            <li>
                                <a [href]="Content.mainImg"
                                   class="popup-btn"
                                   title="Zoom Image">
                                    <i class="bx bx-scan"></i>
                                </a>
                            </li>

                            <li>
                                <a [routerLink]="['/product', Content.keywords]"
                                   title="Product Details">
                                    <i class="bx bx-link"></i>
                                </a>
                            </li>

                        </ul>

                    </div>

                    <!-- Product Content -->
                    <div class="products-content">

                        <h3>
                            <a [routerLink]="['/product', Content.keywords]">
                                {{Content.title}}
                            </a>
                        </h3>

                        <!-- Price -->
                        <div class="price">

                            <span class="new-price">
                                {{Content.newPrice}}
                            </span>

                            <span class="old-price"
                                  *ngIf="Content.oldPrice">
                                {{Content.oldPrice}}
                            </span>

                        </div>

                    </div>

                    <!-- Sale -->
                    <span class="on-sale" *ngIf="Content.sale">
                        {{Content.sale}}
                    </span>

                    <!-- Out of Stock -->
                    <div class="out-of-stock" *ngIf="Content.outOfStock">
                        {{Content.outOfStock}}
                    </div>

                </div>

            </div>

        </div>

    </div>

</div>